function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;fill-rule:evenodd;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M21.579,75c-5.756,0-10.438-4.683-10.438-10.439V15.439c0-5.756,4.683-10.439,10.438-10.439h16.374c1.241,0,2.251,1.01,2.251,2.251s-1.01,2.252-2.251,2.252h-16.374c-3.273,0-5.936,2.663-5.936,5.936v49.123c0,3.273,2.663,5.936,5.936,5.936h16.374c1.241,0,2.251,1.01,2.251,2.251s-1.01,2.252-2.251,2.252h-16.374ZM54.327,54.532c-.601,0-1.167-.234-1.592-.659-.877-.878-.877-2.306,0-3.184l8.437-8.437h-31.406c-1.241,0-2.251-1.01-2.251-2.251s1.01-2.252,2.251-2.252h31.407l-8.437-8.437c-.877-.878-.877-2.306,0-3.184.425-.425.991-.659,1.592-.659s1.167.234,1.592.659l12.281,12.281c.877.878.877,2.306,0,3.184l-12.28,12.281c-.425.425-.991.659-1.592.659Z"
});

var SvgNavLogout = function SvgNavLogout(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    viewBox: "0 0 80 80",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNavLogout, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/nav_logout.17bceaf0.svg";
export { ForwardRef as ReactComponent };